
import { getToken } from "firebase/messaging";
import { getFirebaseMessaging } from "./firebase";
import { saveFcmToken } from "../CommonUrl";
import { postClientUrlWithToken } from "../Utils/restUtils";
import { setDeviceToken } from "../Redux/Reducer";

export const createAndSaveFcmToken = async (authInfo, dispatch) => {
  try {
    if (typeof Notification === "undefined") return null;

    const userId = authInfo?.company_user_id || authInfo?.userId;
    const companyId = authInfo?.active_company ?? authInfo?.companyId;
    const url = authInfo?.url || authInfo?.apiUrl;

    if (!userId || companyId === undefined || companyId === null || !url) {
      return null;
    }

    if (Notification.permission === "granted") {
      const messaging = await getFirebaseMessaging();
      if (!messaging) return null;

      const token = await getToken(messaging, {
        vapidKey: 'BBkKMOd1Gm4VRz5JFzB6tXnmVelTy11kFJFZdNXQLXF3P0J1GpBJ8cDxQpeoDrUGq1JNiDjC9Wac8bT8GOfunyE',
      });

      if (token) {
        if (dispatch) {
          dispatch(setDeviceToken(token));
        }

        const postData = {
          user_id: userId,
          device_token: token,
          company_id: companyId,
        };

        await postClientUrlWithToken(url, saveFcmToken, postData);
        return token;
      }
    }
  } catch (err) {
    console.error("An error occurred while creating/retrieving FCM token:", err);
  }
  return null;
};

export const requestAndSaveFcmToken = async (authInfo, dispatch) => {
  try {
    if (typeof Notification === "undefined") return null;
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      return await createAndSaveFcmToken(authInfo, dispatch);
    }
  } catch (err) {
    console.error("An error occurred while requesting notification permission:", err);
  }
  return null;
};

export const sendFcmToken = async (data) => {
  const authInfo = data?.data || data;
  return await requestAndSaveFcmToken(authInfo);
};


   